import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Content from "../components/Content"

const IndexPage = () => (
  <Layout>
    <SEO title="Aleksandra Makulska" />
    <Content />
  </Layout>
)

export default IndexPage
